'use es6';

// Copied from https://git.hubteam.com/HubSpot/ContentEditorUI/blob/master/ContentEditorUI/static/js/utils/reduceReducers.js
export default function reduceReducers(...reducers) {
  return (previous, current) => reducers.reduce((p, r) => r(p, current), previous);
}